const editorial = [
    {
        id: "modern-gallery",
        name: "Modern Gallery",
        ornament: "none",
        radius: "sharp",
        fonts: {
            display: "Syne",
            heading: "Syne",
            body: "Outfit",
        },
        colors: {
            bg: "#f6f6f4",
            bgAlt: "#ececea",
            surface: "#ffffff",
            primary: "#111111",
            primaryHover: "#000000",
            accent: "#c4342d",
            accentSoft: "#e6e6e4",
            rose: "#c4342d",
            roseDeep: "#c4342d",
            leaf: "#111111",
            text: "#111111",
            textMuted: "#5c5c5a",
            border: "#d2d2cf",
            buttonText: "#ffffff",
        },
    },
    {
        id: "pearl-blush",
        name: "Pearl and Blush",
        ornament: "floral",
        radius: "round",
        fonts: {
            display: "Cormorant Garamond",
            heading: "Newsreader",
            body: "Outfit",
        },
        colors: {
            bg: "#fbf8f6",
            bgAlt: "#f3eeeb",
            surface: "#fffcfb",
            primary: "#8d7370",
            primaryHover: "#6a5552",
            accent: "#e6d3cc",
            accentSoft: "#f4ebe7",
            rose: "#f0e4df",
            roseDeep: "#6f5854",
            leaf: "#cfc3bc",
            text: "#4a3f3d",
            textMuted: "#8a7c78",
            border: "#e5dbd6",
            buttonText: "#fffaf8",
        },
    },
    {
        id: "nile-papyrus",
        name: "Nile Papyrus",
        ornament: "linear",
        radius: "soft",
        fonts: {
            display: "Italiana",
            heading: "EB Garamond",
            body: "Libre Baskerville",
        },
        colors: {
            bg: "#e7d7b8",
            bgAlt: "#dcc9a4",
            surface: "#f3e6c8",
            primary: "#1c1a17",
            primaryHover: "#000000",
            accent: "#1e4d8c",
            accentSoft: "#d4e1f2",
            rose: "#c4a574",
            roseDeep: "#6e4b24",
            leaf: "#8c6a3d",
            text: "#1c1a17",
            textMuted: "#5c5146",
            border: "#c4b08a",
            buttonText: "#f6edd6",
        },
    },
];

export default editorial;
